import Text from '@/app/components/common/Text'
import PriceSlider from '@/app/components/PriceSlider'
import { Filters } from '@/app/types'
import { useTranslations } from 'next-intl'
import { FC } from 'react'

interface PriceFilterProps {
	localValue: Filters
	availableRates: { min: number; max: number }
	handlePriceRangeChange: (newValues: [number, number]) => void
}

const PriceFilter: FC<PriceFilterProps> = ({
	localValue,
	availableRates,
	handlePriceRangeChange,
}) => {
	const t = useTranslations('Keywords')

	return (
		<div className="hotel-list-filters__section">
			<Text size="lg" font={'semibold'} className="hotel-list-filters__title">
				{t('pricePerNight')}
			</Text>
			<PriceSlider
				onValuesChange={handlePriceRangeChange}
				valuesRange={availableRates}
				initialValues={localValue.priceRange as [number, number]}
			/>
		</div>
	)
}

export default PriceFilter
